<template>
  <div>
    <label :for="name">{{ label }}</label>
    <div v-if="list.length" class="d-flex flex-wrap border rounded mb-2">
      <div
        class="badge badge-secondary m-1 d-flex flex-wrap"
        v-for="(item, index) in list"
        :key="index"
        :value="item"
      >
        {{ item }}
        <a href="#" @click="removeFromList(index)">
          <Icon icon="close" :size="10" class="ml-1" />
        </a>
      </div>
    </div>
    <div class="d-flex align-items-end mb-2">
      <input
        class="form-control mr-2"
        ref="input"
        :name="name"
        :type="type"
        :placeholder="placeholder"
      />
      <Btn @click="addToList()" :variant="'primary'">
        {{ $t("global.add") }}
      </Btn>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import FormMixin from "@/components/display/form/FormMixin";
import Icon from "@/components/display/icon/Icon";
import { ref } from "@vue/composition-api";

export default {
  name: "FormCustomListInput",
  mixins: [FormMixin],
  props: {
    name: String,
    type: {
      type: String,
      default: "text",
    },
    value: Array,
  },
  components: {
    Btn,
    Icon,
  },
  setup(props, { emit }) {
    const input = ref(null);
    const list = [];

    const addToList = () => {
      if (input.value.value && input.value.checkValidity()) {
        if (!list.includes(input.value.value)) {
          list.push(input.value.value);
        }

        input.value.value = "";
        emit("input", list);
      } else {
        input.value.reportValidity();
      }
    };

    const removeFromList = (index) => {
      list.splice(index, 1);
    };

    return {
      input,
      addToList,
      removeFromList,
      list,
    };
  },
};
</script>

<style lang="scss" scoped></style>
